import type { ApiContext, FeePolicy } from "@hobbyshopify/backend-client";
import type { AsyncResult } from "operation-result.js";
import type { AuthHandler } from "trunk.js";
import type { BackendApi } from "./api";

/** The rates the wizard quotes: the back-office policy, read live so the sentence cannot drift from the bill. */
export function loadFeePolicy(o: {
  client: BackendApi;
  authHandler: AuthHandler<ApiContext>;
}): AsyncResult<FeePolicy, never> {
  return o.authHandler.callApi((ctx) => o.client.fees.current(ctx));
}
